import { render, staticRenderFns } from "./Specs.vue?vue&type=template&id=158809bc&scoped=true&"
import script from "./Specs.vue?vue&type=script&lang=js&"
export * from "./Specs.vue?vue&type=script&lang=js&"
import style0 from "./Specs.vue?vue&type=style&index=0&id=158809bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158809bc",
  null
  
)

export default component.exports